

exports.__esModule = true;
exports.showCartDecision = showCartDecision;
var _pxp = require("./pxp");
function showCartDecision(isWps, total, merchantCountry, merchantId, noLineItemDetails, isPurchase) {
  return (0, _pxp.$pxpCartAmt)(merchantCountry, merchantId, noLineItemDetails, isPurchase).then(function (showAmount) {
    // Show cart subtotal if there is a total amount
    // Do not show subtotal for wps subscription flow.
    // Show amount in cart icon only if showAmount is truthy and total amount is not zero
    return {
      showAmt: showAmount,
      showCartSubTotal: showAmount && total && !isWps,
      //  checking for  isWpsSubscriptionFlow & isWpsInstallmentPlan & isWpsAutobillingFlow
      showAmountInCartIcon: showAmount && +total.amount !== 0
    };
  });
}
_pxp.$pxpCartAmt;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-page-components/src/cart/lib/showCartDecision.js
// module id = ../node_modules/xo-page-components/src/cart/lib/showCartDecision.js
// module chunks = 0